import React, { useState } from "react";
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import AdminSidebar from "./AdminSidebar";
import { listItems } from "../../../utils/navigation";
import Logo from "../../../assets/images/j_nine_infotech_logo.png";

const drawerWidth = 240;

const AdminLayout = ({ children, login, onLogout }) => {
    const isMdUp = useMediaQuery("(min-width:960px)");
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawerContent = (
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 4, px: 2 }}>
                <img src={Logo} alt="Logo" style={{ width: "40px", borderRadius: "8px" }} />
                <Typography variant="h6" fontWeight="bold" color="primary">Admin</Typography>
            </Box>
            <List>
                {listItems.map((item, index) => {
                    // Clone to set mobile styling
                    const Icon = React.cloneElement(item.icon, { color: "currentColor", size: 24, variant: "Bulk" });
                    const isActive = location.pathname === item.link;

                    return (
                        <ListItem
                            button
                            key={index}
                            onClick={() => { navigate(item.link); handleDrawerToggle(); }}
                            sx={{
                                mb: 1,
                                borderRadius: "12px",
                                bgcolor: isActive ? "primary.main" : "transparent",
                                color: isActive ? "white" : "text.secondary",
                                "&:hover": {
                                    bgcolor: isActive ? "primary.dark" : "rgba(0,0,0,0.04)"
                                }
                            }}
                        >
                            <ListItemIcon sx={{ color: "inherit", minWidth: "40px" }}>{Icon}</ListItemIcon>
                            <ListItemText primary={item.head} primaryTypographyProps={{ fontWeight: 500 }} />
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );

    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100vh",
                backgroundColor: "#f5f7fa",
                backgroundImage: `
          radial-gradient(at 0% 0%, rgba(200, 210, 255, 0.3) 0px, transparent 50%), 
          radial-gradient(at 100% 0%, rgba(200, 255, 240, 0.3) 0px, transparent 50%),
          radial-gradient(at 100% 100%, rgba(255, 220, 220, 0.3) 0px, transparent 50%),
          radial-gradient(at 0% 100%, rgba(240, 230, 255, 0.3) 0px, transparent 50%)
        `,
                backgroundAttachment: "fixed",
            }}
        >
            {/* Desktop Sidebar (Floating) */}
            {isMdUp && <AdminSidebar />}

            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: "block", md: "none" },
                    "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth, borderRadius: "0 20px 20px 0", borderRight: "none" },
                }}
            >
                {drawerContent}
            </Drawer>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 2, md: 3 },
                    ml: { xs: 0, md: "120px" },
                    mt: { xs: "80px", md: "100px" },
                    mr: { xs: 0, md: "20px" },
                    mb: "20px",
                    width: { xs: "100%", md: "calc(100% - 140px)" },
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    minHeight: "calc(100vh - 120px)",
                    borderRadius: "24px",
                }}
            >
                <AdminNavbar login={login} onLogout={onLogout} onDrawerToggle={handleDrawerToggle} />
                {children}
            </Box>
        </Box>
    );
};

export default AdminLayout;
